export default "__VITE_ASSET__BeC08nDX__"